import type { ReactNode } from 'react';

import { CreditApplicantField } from './CreditApplicantField';
import type { LoanType } from '../../../types';

type Props = {
    name: `${LoanType}.${number}`;
    disabled: boolean;
    left: ReactNode;
    right: ReactNode;
};

export const LoanFormLayout: React.FC<Props> = ({ disabled, left, name, right }) => (
    <div className="grid gap-x-8 gap-y-2 lg:grid-cols-2">
        <div className="flex flex-col gap-2">
            <CreditApplicantField name={name} disabled={disabled} />
            {left}
        </div>
        <div className="flex flex-col gap-2">{right}</div>
    </div>
);
